import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NameField from 'components/forms/new/formikFormFields/NameField';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const LocationNameField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isRequired
            isInvalid={!!errors.location && touched.location}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>Location</FormLabel>
                <Field
                    name="location"
                    render={({ field }) => (
                        <NameField
                            {...field}
                            pl={2}
                            placeholder="Enter location name"
                            label="Location *"
                            darkMode={darkMode}
                        />
                    )}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Enter a display name for this location"
                        ariaLabel="location-name-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError error={errors?.location} touched={touched?.location} />
        </FormControl>
    );
};

export default LocationNameField;
